module.exports = __webpack_public_path__ + "vue_assets/img/img_assetpack_wonders.a02a7313.jpg";